import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { func } from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import SideBar from "../SideBar/SideBar";
import brandTheme from "brandTheme/Theme";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";


const useStyles = makeStyles(({theme}) => ({
    container:{
      display:'flex',
      width:'100%',
      marginTop:'1%',
      // height:'calc(100% - 140px)',
      overflowY:'auto',
    },
    content:{
        width:'calc(100% - 260px)',
        "@media (max-width: 960px)": {
          width:'100%',
          overflowY:'hidden'
        },
        '& .inputFieldContainer': {
          maxWidth: "1050px",
          margin: "0 auto",
        },
        '& .fieldContaienr':{
          margin: "2% 2% 0px 2%",
          maxWidth: "28%",
          "@media (max-width: 768px)": {
            maxWidth:'46%',
            margin: "5% 2% 0px 2%",
          },
          "@media (max-width: 600px)": {
            maxWidth:'100%',
          },
          "@media (max-width: 450px)": {
            margin:"10% 2% 0px 2%"
          },
        },
       '& $header': {
          fontSize: brandTheme.headerFontSize,
          fontWeight: 700,
          lineHeight: "1.5rem",
          fontFamily: brandTheme.font.poppins,
          margin: "2% 2% 0px 2%",
        },
    }
  }));


const InnerContent = ({
  handleDrawerToggle,
  mobileOpen,
  outletData,
  sideBarLinks,
  enabled,
  roleUser,
  designation
}) => {
  const [filteredSidebarTabs, setFilteredSidebarTabs] = useState(sideBarLinks);
  const [callInProgress, setCallInProgress] = useState(false);
  const [checkSearchData, setCheckSearchData] = useState(false);

  const classes = useStyles();

  const repaymentFlag = sessionStorage.getItem("RepaymentFlag") === "true";

  const checkFlagData = filteredSidebarTabs;

  useEffect(() => {
    if (checkFlagData?.length === 0 && !checkSearchData) {
      setCallInProgress(true);
    } else {
      setCallInProgress(false);
    }
  }, [checkFlagData, checkSearchData]);

  if(callInProgress){
      return (
        <CircularProgresss callInProgress={callInProgress} />
      )}
  return (
    <div className={classes.container}>
      {/* Hide Sidebar when RepaymentFlag is true */}
      {!repaymentFlag && (
        <div>
          <SideBar
            handleDrawerToggle={handleDrawerToggle}
            open={mobileOpen}
            featureFlag={outletData}
            checkFlagData={checkFlagData}
            filteredSidebarTabs={filteredSidebarTabs}
            setFilteredSidebarTabs={setFilteredSidebarTabs}
            setCheckSearchData={setCheckSearchData}
            checkSearchData={checkSearchData}
            enabled={enabled}
            designation={designation}
            roleUser={roleUser}
          />
        </div>
      )}

      <div
        className={classes.content}
        style={{
          width: repaymentFlag ? "100%" : undefined,
        }}
      >
        <Outlet context={outletData} />
      </div>

    </div>
  );
};

InnerContent.propTypes = {
  handleDrawerToggle: func,
};
export default InnerContent;
